/* eslint-disable react/display-name */
import Checkbox from 'apollo-react/components/Checkbox';
import React from 'react';

const QueueMultiSelectCell = (selections, handleSelect) => {
  return ({ row }) => {
    const checked =
      selections.find((s) => s[s.PrimaryKeyColumn] === row[row.PrimaryKeyColumn]) !== undefined;

    return (
      <span>
        <Checkbox
          checked={checked}
          onChange={(e, _checked) => handleSelect(_checked, row)}
          aria-label="Monitoring Multi Select"
        />
      </span>
    );
  };
};

export default QueueMultiSelectCell;
